import React from 'react';
import { Route } from 'react-router-dom';

import Landing from 'features/Home';

const Routes = () => (
  <Route component={Landing} />
);

export default Routes;
